export default __webpack_public_path__ + "static/media/yinhua.204b96b6.png";